import {QueryCommand} from "xmgoing-server";
import {StorageUtils, getUrlParams, deepClone} from 'xmgoing-utils';
import SysConfigUtils from "@/utils/sysConfigUtils";
import emptyPage from "../data/emptyPage";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {
  loadContentById, loadDetailByPageIdApi
} from "@/main-page-base/ctls/containers/xmPageContent/server/xmPageContentSever";
import eventBus from "@/events/eventBus";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {decodeJsContentStr} from "@/main-page/jsParseEngine/jsParse";
import {
  loadDesInfosByApi,
  loadDesInfosByCodeSev,
  loadDesInfosByModuleApi
} from "@/api/domainApi/domainComApi";
import {getFormDesByJsonStrByFormKey} from "@/main-page/tempUseUtils/pageTempInit/commonFormDes";




export function useLoadDesInfo({
                                 emits=null,
                                 events,
                                 props,
                                 menuId = '',
                                 pageId = '',
                                 moduleCode,
                                 pageCode,
                                 formKey,
                                 pageLoadingFlag
                               }, afterLoadBackFun = function (configs) {
}) {
  const showContentFlag=ref(true);
  if((unref(props).showNoDataInfo+'')!=='true'){
    showContentFlag.value=false;
  }
  const {clickEvent, viewModel} = useComEvent({events});

  const pageConfigs: any = ref(emptyPage);
  const loadPageFlag = ref(true);
  if(showContentFlag.value){
    loadPageFlag.value=false;
  }
  setTimeout(() => {
    loadPageFlag.value = false;
  }, 5000)
  const pageModelsStore: any = usePageModelsStore();
  const dataSourceStore: any = useDataSourceStore();
  const noPageDes = ref(false);

  const afterLoadJson = function (datas, pageCodeVal) {
    const versionItem = datas;
    try {
      //设计信息
      const infoSettingJson = versionItem?.infoSettingJson;
      //数据源信息
      const dataSourceConfig = versionItem?.infoSettingJsonTwo;
      if (infoSettingJson) {
        if(unref(formKey)){
          pageConfigs.value = {blocks:[getFormDesByJsonStrByFormKey(typeof infoSettingJson === 'string'
              ? JSON.parse(decodeJsContentStr(infoSettingJson))
              : infoSettingJson,unref(formKey))]};
        }else{
          // 必须先写入设计稿再 initStore，否则 merge 的是空 pageConfigs
          pageConfigs.value = typeof infoSettingJson === 'string'
            ? JSON.parse(decodeJsContentStr(infoSettingJson))
            : infoSettingJson;
        }
        pageModelsStore.initStoreByConfig(pageModelsStore, pageConfigs, false);
        afterLoadBackFun && afterLoadBackFun(pageConfigs);
        nextTick(() => {
          clickEvent('onAfterMounted', {});
        })
        if (dataSourceConfig && dataSourceConfig!)
          dataSourceStore.setDataSourceList(
            typeof dataSourceConfig === 'string' ? JSON.parse(decodeJsContentStr(dataSourceConfig)) : dataSourceConfig,
            pageModelsStore);
      }
      showContentFlag.value=false;
      loadPageFlag.value = false;
      emits&&emits('closeLoading',{});
    } catch (e) {
      showContentFlag.value=false;
      loadPageFlag.value = false;
      emits&&emits('closeLoading',{});
    }
    StorageUtils.addSessionItem(pageCodeVal + "_userDef2Page", datas.infoSettingJson);
  }

  /**
   * 根据pageId获取设计信息
   */
  const loadDetailByPageId = function () {
    loadDetailByPageIdApi({pageId}, (datas) => {
      pageLoadingFlag.value = false;
      if (datas && datas.infoSettingJson) {
        afterLoadJson(datas, pageId);
      }
    });
  }
  /**
   * 加载设计信息
   * @param pageCodeVal
   */
  const loadDesInfos = function (pageCodeVal) {
    loadDesInfosByApi({pageCodeVal, moduleCode}, (datas) => {
      pageLoadingFlag.value = false;
      if (datas && datas.infoSettingJson) {
        afterLoadJson(datas, pageCodeVal);
      }
    })
  };

  /**
   * 获取自定义界面对设计信息
   * @param pageCode
   * @param moduleCode
   */
  const loadDesInfosByModule = function (pageCode, moduleCode) {
    loadDesInfosByModuleApi({pageCode, moduleCode}, (datas) => {
      pageLoadingFlag.value = false;
      loadPageFlag.value = false;
      nextTick(()=>{
        emits&&emits('closeLoading',{});
      })
      if (datas && datas.infoSettingJson) {
        afterLoadJson(datas, pageCode);
      } else {
        noPageDes.value = true;
      }
    });
  }


  /**
   * 获取表单界面的设计信息
   * @param pageCodeVal
   */
  const loadDesInfosByCode = function (pageCodeVal) {
    loadDesInfosByCodeSev(pageCodeVal, (datas) => {
      pageLoadingFlag.value = false;
      if (datas && datas.infoSettingJson) {
        afterLoadJson(datas, pageCode);
      }
    });
  };


  /**
   * 加载界面配置信息
   * @param backFun
   */
  const loadDesPageConfigInfos = function (backFun) {
    try {
      const configs = StorageUtils.getSessionItem(pageCode + "_userDefPcage_pageCodeConfig");
      if (configs) {
        pageLoadingFlag.value = false;
        backFun && backFun(JSON.parse(configs));
        return
      }
    } catch (e) {
      StorageUtils.removeSessionItem(pageCode + "_userDefPage_pageCodeConfig");
      loadDesPageConfigInfos(backFun);
    }
    //获取界面id
    const queryCommand = new QueryCommand({
      method: "GET",
      url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/baseConfig/getByPageCode'
    });
    //执行查询操作
    queryCommand.executeQuery({
      params: {pageCode}, successFun: (datas) => {
        pageLoadingFlag.value = false;
        let configJsonObj = {};
        if (datas && datas.configJson) {
          configJsonObj = JSON.parse(datas.configJson)
        }
        StorageUtils.addSessionItem(pageCode + "_userDefPage_pagdeCodeConfig", datas);
        backFun && backFun(configJsonObj);
      }
    });
  };


  const clearCache = function (pageCodeVal) {
    StorageUtils.removeSessionItem(pageCodeVal + "_userDefPage")
  }

  /**
   * 获取当前界面的设计信息
   * @param pageCodeVal
   * @param moduleCodeVal
   */
  const getCurPageDes = function (pageCodeVal, moduleCodeVal) {
    const pageConfigsCache = StorageUtils.getSessionItem(pageCodeVal + "_userDecfPage");
    //如果存在缓存 则从缓存中读取
    if (pageConfigsCache && getUrlParams("appId", true) == null) {
      try {
        pageConfigs.value = JSON.parse(pageConfigsCache);
        pageModelsStore.initStoreByConfig(pageModelsStore, pageConfigs, false);
        afterLoadBackFun && afterLoadBackFun(pageConfigs);
        nextTick(() => {
          clickEvent('onAfterMounted', {});
        })
        pageLoadingFlag.value = false;
        loadPageFlag.value = false;
        emits&&emits('closeLoading',{});
      } catch (e) {
        if (moduleCodeVal) {
          loadDesInfosByModule(pageCodeVal, moduleCodeVal);
        } else {
          loadDesInfos(pageCodeVal);
        }
      }
    } else {
      //如果是自定义的表单记录 则根据表单信息查询
      if (moduleCodeVal === 'appPage') {
        //获取表单界面的设计信息
        loadDesInfosByCode(pageCodeVal);
      } else {
        if (moduleCodeVal) {
          loadDesInfosByModule(pageCodeVal, moduleCodeVal);
        } else {
          loadDesInfos(pageCodeVal);
        }
      }
    }
  }


  /**
   * 动态获取设计信息
   */
  if (unref(props).tableCode && unref(props).fieldName && pageModelsStore['state'][unref(props)['fieldValue']]) {
    loadContentById({props, recordId: pageModelsStore['state'][unref(props)['fieldValue']]}, (res) => {
      pageConfigs.value = typeof res.formJson === 'string' ? JSON.parse(res.formJson) : res.formJson;
      loadPageFlag.value = false;
      emits&&emits('closeLoading',{});
      nextTick(() => {
        clickEvent('onAfterMounted', {});
      })
    });
  } else {
    if (unref(menuId) && unref(pageId)) {
      //获取界面设计信息
      loadDetailByPageId();
    } else {
      //根据界面code获取设计信息
      if (unref(pageCode)) {
        /**
         * 加载设计信息
         */
        getCurPageDes(pageCode, moduleCode);
      }
    }
  }

  /**
   * 初始化表单对象值
   */
  const initFormObjValue = function ({fieldName, res}) {
    const formObj = deepClone(res);
    setTimeout(() => {
      const pageContentEl = document.querySelector("#" + unref(props).key);
      if (pageContentEl) {
        const xmFormEl = pageContentEl?.querySelector(".xmFormBody");
        if (xmFormEl) {
          const formId = xmFormEl.getAttribute("id");
          if (formId) {
            delete formObj[fieldName || 'formJson'];
            pageModelsStore.state[formId] = formObj;
          }
        }
      }
    }, 300);
  }

  /**
   * 获取部件设计信息
   * @param pageCode
   * @param moduleCodeVal
   */
  const _setXmPageContentCode=({pageCode,moduleCodeVal}) => {
    if (pageCode) {
      loadPageFlag.value = true;
      pageConfigs.value = emptyPage;
      getCurPageDes(pageCode, moduleCodeVal||'appPage');
    }
  }

  /**
   *
   * @param domainCode
   * @param recordId
   * @param fieldName
   */
  const _getDoaminJsonToPageContent=({domainCode, recordId, fieldName}) => {
    if (domainCode) {
      pageConfigs.value = emptyPage;
      loadPageFlag.value = true;
      loadContentById({props: {tableCode: domainCode}, recordId: recordId}, (res) => {
        pageConfigs.value = typeof res[fieldName || 'formJson'] === 'string' ? JSON.parse(res[fieldName || 'formJson']) : res[fieldName || 'formJson'];
        loadPageFlag.value = false;
        emits&&emits('closeLoading',{});
        nextTick(() => {
          clickEvent('onAfterMounted', {});
        })
        initFormObjValue({fieldName, res});
      });
    }
  }

  onBeforeUnmount(() => {
    eventBus.off('setXmPageContentCode' + unref(props).key,_setXmPageContentCode);
    eventBus.off('getDoaminJsonToPageContent',_getDoaminJsonToPageContent);
  })

  onMounted(() => {
    eventBus.off('setXmPageContentCode' + unref(props).key,_setXmPageContentCode);
    eventBus.on('setXmPageContentCode' + unref(props).key,_setXmPageContentCode);

    eventBus.off('getDoaminJsonToPageContent',_getDoaminJsonToPageContent);
    eventBus.on('getDoaminJsonToPageContent',_getDoaminJsonToPageContent);
  })
  return {
    showContentFlag,
    noPageDes,
    clearCache,
    getCurPageDes,
    loadDesPageConfigInfos,
    loadPageFlag,
    loadDesInfos,
    pageConfigs
  }
}
